import React, { useState } from 'react';
import { saveHoliday, removeHoliday } from './attendanceApi';

// Mark (or un-mark) a single day or a date range as a holiday.
// Class teachers affect only their class; global roles can apply to the whole school.
export default function HolidayDialog({ user, className, isGlobal, initialDate, onClose, onDone }) {
  const [from, setFrom] = useState(initialDate);
  const [to, setTo] = useState(initialDate);
  const [title, setTitle] = useState('');
  const [wholeSchool, setWholeSchool] = useState(false);
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);

  const run = async (remove) => {
    setErr('');
    if (!remove && !title.trim()) { setErr('Enter a holiday name'); return; }
    setBusy(true);
    try {
      const classes = [wholeSchool ? 'all' : className];
      if (remove) await removeHoliday(user, { classes, from, to });
      else await saveHoliday(user, { classes, from, to, title: title.trim() });
      onDone();
    } catch (e) {
      setErr(e.response?.data?.error || 'Failed');
    } finally { setBusy(false); }
  };

  return (
    <div className="am-modal" onClick={onClose}>
      <div className="am-sheet" onClick={(e) => e.stopPropagation()}>
        <h3>🏖 Holiday – {className}</h3>
        <div className="am-field">
          <label className="am-label">From</label>
          <input type="date" className="am-date" value={from} onChange={(e) => { setFrom(e.target.value); if (e.target.value > to) setTo(e.target.value); }} />
        </div>
        <div className="am-field">
          <label className="am-label">To</label>
          <input type="date" className="am-date" value={to} min={from} onChange={(e) => setTo(e.target.value)} />
        </div>
        <div className="am-field">
          <label className="am-label">Holiday name</label>
          <input className="am-date" value={title} onChange={(e) => setTitle(e.target.value)} placeholder="e.g. Diwali Break" />
        </div>
        {isGlobal && (
          <label className="am-check">
            <input type="checkbox" checked={wholeSchool} onChange={(e) => setWholeSchool(e.target.checked)} /> Apply to whole school
          </label>
        )}
        <div className="am-note">Sundays inside the range are skipped. Max 62 days at once.</div>
        {err && <div className="am-err">{err}</div>}
        <div className="am-modal-btns">
          <button className="primary" disabled={busy} onClick={() => run(false)}>Mark Holiday</button>
          <button className="danger" disabled={busy} onClick={() => run(true)}>Remove</button>
          <button className="plain" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
}
